export const getTaskEventType = [
    {"index": 1, "desc": "尚产兴业，助力乡村产业振兴"},
    {"index": 2, "desc": "尚才兴教，助力乡村人才振兴"},
    {"index": 3, "desc": "尚文兴德，助力乡村文化振兴"},
    {"index": 4, "desc": "尚勤兴美，助力乡村生态振兴"},
    {"index": 5, "desc": "尚进兴基，助力乡村组织振兴"}]


